import { render, staticRenderFns } from "./TaxiTransactionDetails.vue?vue&type=template&id=33dbbda0"
import script from "./TaxiTransactionDetails.vue?vue&type=script&lang=js"
export * from "./TaxiTransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./TaxiTransactionDetails.vue?vue&type=style&index=0&id=33dbbda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports